import { MessageCircle } from "lucide-react";
import { useState } from "react";

export default function WhatsAppButton() {
  const phoneNumber = "+33 665753833"; 
  const [hover, setHover] = useState(false);

  const openWhatsApp = () => {
    window.open(`https://wa.me/${phoneNumber}`, "_blank"); // Fixed template literals
  };

  return (
    <div
      className="fixed bottom-6 right-6 flex items-center space-x-2"
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      {/* Tooltip text */}
      {hover && (
        <span className="bg-gray-800 text-white px-3 py-1 rounded-lg text-sm transition-opacity">
          Contactez-nous sur WhatsApp
        </span>
      )}

      <button
        onClick={openWhatsApp}
        className="bg-green-500 text-white p-4 rounded-full shadow-lg hover:bg-green-600 transition"
      >
        <MessageCircle size={35} />
      </button>
    </div>
  );
}
 